function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.22 17.8L30.72 3.55A2.25 2.25 0 0027 5.25v7.5c-15.06.18-27 3.2-27 17.47 0 5.76 3.71 11.46 7.81 14.45 1.28.93 3.1-.24 2.63-1.75C6.2 29.32 12.46 25.72 27 25.51v8.24a2.25 2.25 0 003.72 1.7l16.5-14.25a2.25 2.25 0 000-3.4z"
})));